/* c8 ignore start */
import cards from "./cards";
import history from "./history";
import lures from "./lures";

export default {
  cards,
  history,
  lures,
};
/* c8 ignore end */
